<div data-at-no-data id="no-data" class="flex flex-col gap-[40px] justify-center items-center">
  <div data-at-icon class="icon centered flex-[330px] max-w-[330px]">
    <img src="/assets/img/devices/{{ icon }}.png" />
  </div>
  <div data-at-message class="message centered">
    <ng-content></ng-content>
  </div>
  <div
    data-at-invitations-button
    *ngIf="invitationsCount > 0"
    class="invitations-button centered flex-[40px] max-w-[40px]"
  >
    <button
      data-at-button
      mat-raised-button
      gtm="onGoToPage"
      gtmAction="Invitations"
      gtmCategory="noData"
      [routerLink]="['/invitations']"
    >
      {{ '+INSTALLATIONS.INSTALLATIONS.CONNECTION.SEE_REQUESTS' | translate }} ({{
        invitationsCount
      }})
    </button>
  </div>
</div>
